module.exports = __webpack_public_path__ + "img/registration-screenshot2.3a9c2ac2.png";